/** @format */

export const DELAY_TIME = 1;
export const LONG_TIME = 2;
export const TIME = 0.8;
